























export default {
  name: "SelectFilter",
  props: ['confirm', 'clearFilters', 'value', 'options', 'defaultValue'],

  methods: {
    changeValue(value?: any) {
      // @ts-ignore
      this.$emit('change', value || this.defaultValue)
    }
  }
}
